import { Card } from '@app/components/various/Card';

export const BuyersListCardSkeleton = () => {
  return (
    <Card.Wrapper variant="gray">
      <Card.Title isLoading />
      <Card.AttributeList isLoading skeletonRows={3} />
    </Card.Wrapper>
  );
};
